<template>
  <div>
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem to="/exhibition/index">管理</BreadcrumbItem>
          <BreadcrumbItem>案例</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">{{exhibition.name}}</div>
      </div>
      <div class="header-tool-box" @click="$router.push('/exhibition/index/case/add')">
        <div class="htb-item">
          <span class="htb-add">+</span>
          <span>添加案例</span>
        </div>
      </div>
    </div>
    <div class="my-item">
      <template v-if="list && list.items.length">
        <Row :gutter="30">
          <Col
            style="width:20%;float:left"
            v-for="(item, index) in list.items"
            :key="'brandInt-' + index"
          >
            <div class="my-item-box">
              <div class="mi-top">
                <div v-if="!item.isShow" class="case-show">
                  <i class="icon iconfont icon-hide"></i>
                </div>
                <img :src="item.logo" v-if="item.logo" />
                <img src="@assets/img/empty.png" v-else />
              </div>
              <div class="mi-title f-tac" :title="item.name">{{item.name}}</div>
              <div class="mi-tool"> 
                <div class="mi-tool-item z-primary" @click="showEdit(item)">编辑</div>
                <div class="mi-tool-line">|</div> 
                <div class="mi-tool-item">
                  <Dropdown trigger="custom" :visible="item.visible">
                    <a href="javascript:void(0);" style="color:#808080;" @click="toggleOpen(index)">
                      更多
                      <Icon style="margin-left:-3px;" type="ios-arrow-down"></Icon>
                    </a>
                    <DropdownMenu slot="list" style="text-align:center;"> 
                      <DropdownItem v-if="item.isShow" @click.native="showOff(item)">屏蔽</DropdownItem>
                      <DropdownItem v-if="!item.isShow" @click.native="showOn(item)">显示</DropdownItem>
                      <DropdownItem>
                        <Poptip
                          width="160"
                          confirm
                          placement="top-start"
                          title="确认删除此案例吗 ?"
                          @on-ok="delItem(item, index)"
                          @on-cancel="handleClose(index)"
                        >
                          <div style="width: 100px;">删除</div>
                        </Poptip>
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <div class="my-page" v-if="totalCount > pageSize">
          <Page
            show-total
            show-elevator
            :page-size="pageSize"
            :current="pageIndex"
            :total="totalCount"
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </template>
      <div class="u-empty" v-else>暂无数据</div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "successCase",
  data() {
    return {
      deleted: false,
      list: null,
      pageSize: 18,
      pageIndex: 1,
      totalCount: 0
    };
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      exhibition: "loginModule/getExhibition"
    }),
    option() {
      return {
        CompId: this.company.id,
        PageSize: this.pageSize,
        PageIndex: this.pageIndex
      };
    }
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getExample: "companyModule/getExample",
      delExample: "companyModule/delExample",
      editExample: "companyModule/editExample"
    }),
    async init() {
      let result = await this.getExample(this.option);
      if (result) {
        result.items.map(c => {
          if (c.banner) {
            c.banner = JSON.parse(c.banner);
          }
          c.visible = false;
        });
        this.list = result;
        this.pageSize = result.pageSize;
        this.pageIndex = result.pageIndex;
        this.totalCount = result.totalCount;
      }
    },
    async delItem(item) {
      let result = await this.delExample(item.id);
      if (result.successed) {
        this.$Message.success("删除成功");
        this.init();
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
    },
    showEdit(item) {
      this.$router.push(`/exhibition/index/case/edit?id=${item.id}`);
    },
    changePage(e) {
      this.pageIndex = e;
      this.init();
    },
    changePageSize(e) {
      this.pageSize = e;
      this.init();
    },
    // 屏蔽
    async showOff(item) {
      let result = await this.editExample({
        Id: item.id,
        SetValues: {
          IsShow: false
        }
      });
      if (result.successed) {
        this.$Message.success("修改成功");
        this.init();
      } else {
        this.$Message.error("修改失败");
      }
    },
    // 显示
    async showOn(item) {
      let result = await this.editExample({
        Id: item.id,
        SetValues: { IsShow: true }
      });
      if (result.successed) {
        this.$Message.success("修改成功");
        this.init();
      } else {
        this.$Message.error("修改失败");
      }
    },

    handleOpen(index) {
      this.list.items[index].visible = true;
    },
    handleClose(index) {
      this.list.items[index].visible = false;
    },
    toggleOpen(index) {
      let visible = this.list.items[index].visible;
      this.list.items[index].visible = !visible;
    }
  }
};
</script>

<style scoped lang="scss">
.case-show {
  position: absolute;
  z-index: 1;
  right: 0;
  width: 0;
  height: 0;
  border-width: 20px;
  border-style: solid;
  border-color: #ccc #ccc transparent transparent;
  i {
    position: absolute;
    top: -25px;
    right: -20px;
    color: #fff;
    font-size: 25px;
  }
}
</style> 
